import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'

import { Fire, Tools, Popup } from '../../../services'

import Switch from 'react-switch'
import { Headerbar, FormInput, Loader, EditContainer, YesNo, ConfirmLink, ImagesPicker, Select } from '../../Reusable'

import FadeIn from 'react-fade-in';
import AdsList from '../Ads/AdsList'
import ProInfoForm from '../../Pro/ProInfoForm'
import PayoutsList from '../Payouts/PayoutsList'
import UnpaidOrdersList from '../Payouts/UnpaidOrdersList'
import ProValidator from './ProValidator'

import { ASSO_TYPE, PLACE_TYPE, ADS_MAKER_TYPE, ProTypeOptions } from '../../../types/types'

const { useHistory } = require('react-router-dom')

interface Props {
  match: any;
}
const ProScreen: React.FC<Props> = (props) => {

  const [error, setError] = React.useState('')
  const history = useHistory()
  const proId = props.match.params.id
  const tab = props.match.params.tab

  const onFetch = async (id: string) => {
    try {
      const ref = Fire.collection('pros').doc(id)
      const element = await Fire.doc(ref)
      element.logo = Tools.formatPicture(element.logo)
      return element
    } catch (err) {
      setError("Impossible de charger le compte")
      console.warn(err)
    }
    return null
  }

  const saveProInfo = async (info: any, { item, setItem }) => {
    try {
      const data: any = {
        ...info
      }
      data.logo = await Tools.uploadPicture('pros/' + item.id + '/logo.png', data.logo)
      console.log(data.logo)
      
      await Fire.collection('pros').doc(item.id).update(data)
      setItem({ 
        ...item,
        ...info
      })
    } catch (err) {
      console.error(err)
    }
  }

  const deleteAccount = async () => {
    alert('Fonctionnalité bientôt prête !')
  }

  const onSave = async (item: any) => {
    setError('')
    if (!item.type) {
      setError('Veuillez choisir un type de compte')
      return;
    }
    const data = {
      ...item,
      email: (item.email || '').trim(),
    }

    try {
      if (item.id) {
        await Fire.collection('pros').doc(item.id).update(data)
      }
      else {
        const res = await Fire.cloud('createPro', { info: data })
        if (res.error) {
          let error = ''
          switch (res.code) {
            case "auth/invalid-email":
              error = 'Le mail entré est invalide'
              break;

            case "auth/email-already-exists":
              error = 'Le mail entré est déjà utilisé'
              break;

            case "auth/invalid-password":
              error = 'Le mot de passe est trop faible (6 minimum)'
              break;

            default:
              error = 'Vérifiez votre connexion internet'
              break;
          }
          setError(error)
        } else {
          history.push('/admin/pros')
        }
      }
    } catch (err) {
      console.warn(err)
      setError('Vérifiez votre connexion internet')
    }
  }

  const onRemove = async (item: any) => {
    try {
      await Fire.collection('pros').doc(item.id).delete()
      history.push('/admin/pros')
    } catch (err) {
      setError("Impossible de supprimer le compte")
      console.warn(err)
    }
  }

  const renderContent = (tools) => {
    const tab = tools.tab
    if (!tools.item.id || tab === 'account')
      return renderAccount(tools)
    if (tab === 'recap')
      return renderRecap(tools)
    if (tab === 'info')
      return renderInfo(tools)
    if (tab === 'events')
      return renderEvents(tools)
    if (tab === 'discounts')
      return renderDiscounts(tools)
    if (tab === 'places')
      return renderPlaces(tools)
    if (tab === 'payouts')
      return renderPayouts(tools)
    return (null)
  }
  const renderEvents = ({item, tab, onChange, save, saving, changed, setChanged}) => {
    return (
      <AdsList
        title='Evènements'
        type='event'
        proId={proId}
                
        onSelect={(item: any) => history.push('/ads/' + item.type + '/' + item.id + '/info/' + proId)}
        onCreate={() => history.push('/ads/event/new/info/' + item.id)}
        />
    )
  }
  const renderDiscounts = ({item, tab, onChange, save, saving, changed, setChanged}) => {
    return (
      <AdsList
        title='Bons plans'
        type='discount'
        proId={proId}
                
        onSelect={(item: any) => history.push('/ads/' + item.type + '/' + item.id + '/info/' + proId)}
        onCreate={() => history.push('/ads/discount/new/info/' + item.id)}
        />
    )
  }
  const renderPlaces = ({item, tab, onChange, save, saving, changed, setChanged}) => {
    return (
      <AdsList
        title='Points de vente'
        type='place'
        proId={proId}
                
        onSelect={(item: any) => history.push('/ads/' + item.type + '/' + item.id + '/info/' + proId)}
        onCreate={() => history.push('/ads/place/new/info/' + item.id)}
        />
    )
  }
  const renderPayouts = ({item, tab, onChange, save, saving, changed, setChanged}) => {
    return (
      <React.Fragment>
        <UnpaidOrdersList pro={item} />
        <PayoutsList
          title='Virements effectués'
          proId={proId}
                  
          onSelect={(item: any) => void 0}
          onCreate={() => void 0}
          />
      </React.Fragment>
    )
  }
  const renderInfo = (tools: any) => {
    const {item, tab, onChange, save, saving, changed, setChanged} = tools
    return (
      <>
        { item.type !== ADS_MAKER_TYPE &&
          <div className="card">
            <div className="card-header">
              <div className="row spaced-row">
                <h3 className="card-title">Informations paiement</h3>
                { item.stripe_verified ? (
                  <span className="text-success">Configuré <i style={{marginLeft: 10}} className="fa fa-check"></i></span>
                ) : item.stripe_link ? (
                  <span className="text-warning">En configuration</span> 
                ) : (
                  <span className="text-warning">Incomplet</span> 
                )}
              </div>
            </div>
          </div>
        }

        <ProInfoForm
          title='Informations légales'
          pro={item}
          onSave={(data: any) => saveProInfo(data, tools)}
          />
      </>
    )
  }

  const renderRecap = (tools: any) => {
    const {item, tab, onChange, save, remove, saving, changed, setChanged} = tools
    
    const completed = ProValidator.isAccountValid(item)
    return (
      <React.Fragment>
        { item.type === ASSO_TYPE &&
          <div className="row">
            <div className="info-box col-sm">
              <span className="info-box-icon bg-success"><i className="fa fa-shield-alt"></i></span>

              <div className="info-box-content">
                <span className="info-box-text">Activations</span>
                <span className="info-box-number">{item.godchildren_count || 0}</span>
              </div>
            </div>
            <div className="info-box col-sm">
              <span className="info-box-icon bg-success"><i className="fa fa-trophy"></i></span>

              <div className="info-box-content">
                <span className="info-box-text">Conversions</span>
                <span className="info-box-number">{item.godchildren_conversions || 0}</span>
              </div>
            </div>
          </div>
        }

        <div className="row">
          <div className="info-box col-sm">
            <span className="info-box-icon bg-info"><i className="fa fa-eye" style={{fontSize: 26}}></i></span>

            <div className="info-box-content">
              <span className="info-box-text">Total impressions</span>
              <span className="info-box-number">{item.total_impressions || 0}</span>
            </div>
          </div>
          <div className="info-box col-sm">
            <span className="info-box-icon bg-info"><i className="fa fa-street-view" style={{fontSize: 26}}></i></span>

            <div className="info-box-content">
              <span className="info-box-text">Total reach</span>
              <span className="info-box-number">{item.total_impressions_reach || 0}</span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="info-box col-sm">
            <span className="info-box-icon bg-success"><i className="fa fa-hand-pointer"></i></span>

            <div className="info-box-content">
              <span className="info-box-text">Total clics</span>
              <span className="info-box-number">{item.total_views_reach || 0}</span>
            </div>
          </div>
          <div className="info-box col-sm">
            <span className="info-box-icon bg-success"><i className="fa fa-link"></i></span>

            <div className="info-box-content">
              <span className="info-box-text">Total clics billeterie</span>
              <span className="info-box-number">{item.total_clicks_reach || 0}</span>
            </div>
          </div>

        </div>

        <div className="card">
          <div className="card-header">
            <div className="row spaced-row">
              <h3 className="card-title">Statut du compte</h3>
              { completed ? (
                <span className="text-success" style={{cursor:'auto'}}>Compte validé <i style={{marginLeft: 10}} className="fa fa-check"></i></span>
              ) : (
                <span className="text-warning">Compte incomplet</span> 
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }


  const renderAccount = ({item, tab, onChange, save, remove, saving, changed, setChanged}) => {
    return (
      <React.Fragment>
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Compte</h3>
          </div>
          <div className="card-body">
            <div className="item-add-form">
           
              <FormInput
                type="text"
                placeholder="Nom de l'organisation"
                value={item.name}
                onChange={(evt: any) => onChange('name', evt.target.value)}
              />

              <FormInput
                type="text"
                placeholder="Email"
                value={item.email}
                onChange={(evt: any) => onChange('email', evt.target.value)}
              />

              { item.id === undefined &&
                <FormInput
                  type="password"
                  placeholder="Mot de passe"
                  value={item.password}
                  onChange={(evt: any) => onChange('password', evt.target.value)}
                />
              }

              <div style={{marginTop: 10, marginBottom: 10}} className="title">Choisir le type de compte</div>
              <div style={{marginBottom: 20}}>
                <Select
                  value={item.type}
                  onChange={(val: string) => onChange('type', val)}
                  options={ProTypeOptions}
                />
              </div>

              { item.type === ASSO_TYPE &&
                <FormInput
                  type="text"
                  placeholder="Code parrainage"
                  value={item.code}
                  onChange={(evt: any) => onChange('code', evt.target.value)}
                />
              }

              { (item.type === ASSO_TYPE || item.type === PLACE_TYPE) &&
                <YesNo
                  label="Autoriser une billeterie externe"
                  value={item.canDisableTicketing || false}
                  onChange={(ticketing) => onChange('canDisableTicketing', ticketing)}
                  />
              }

            </div>

            <div className="centered">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={save}
                disabled={saving || !changed}
                >
                { saving ? 'Chargement...' : 'Enregistrer' }
              </button>
            </div>
          </div>
        </div>

        { item.id !== undefined &&
          <div className="centered">
            <ConfirmLink
              title='Supprimer'
              className='btn-remove'
              confirmTitle='Êtes-vous sûr de vouloir supprimer ce professionnel ?'
              onPress={remove}
              />
          </div>
        }
      </React.Fragment>
    )
  }

  return (
    <EditContainer
      id={proId}
      error={error}

      onBack={() => history.push('/admin/pros')}
      renderTabs={(item: any) => {
        const list: any[] = [
          {
            title: 'Récap',
            key: 'recap',
          },
          {
            title: 'Compte',
            key: 'account',
          },
          {
            title: 'Infos',
            key: 'info',
          },
        ]
        switch (item.type || '') {
          case ASSO_TYPE:
            list.push({
              title: 'Evènements',
              key: 'events',
            })
            break;
          
          case PLACE_TYPE:
            list.push({
              title: 'Points de ventes',
              key: 'places',
            })
            list.push({
              title: 'Evènements',
              key: 'events',
            })
            break

          case ADS_MAKER_TYPE:
            list.push({
              title: 'Annonces',
              key: 'discounts',
            })
            break

          default:
            break;
        }

        if (item.type !== ADS_MAKER_TYPE) {
          list.push({
            title: 'Virements',
            key: 'payouts',
          })
        }
        return {
          currentTab: tab,
          defaultTab: 'recap',
          tabs: list,
          onSwitchTab: (tab) => history.push('/admin/pro/' + proId + '/' + tab.key)
        }
      }}

      onFetch={onFetch}
      onSave={onSave}
      onRemove={onRemove}
      renderContent={renderContent}
      />
  );
}

export default withRouter(ProScreen)
